
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlozeni-inzeratu",
      function () {
        return require("private-next-pages/vlozeni-inzeratu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlozeni-inzeratu"])
      });
    }
  